<div #profilePhotoReactComponent></div>